<template>
  <form-section
    :direction="direction"
    :error="error"
    :hint="hint"
    :label="label"
    :name="name"
  >
    <textarea
      :id="name"
      :name="name"
      :value="value"
      :placeholder="placeholder"
      :type="type"
      :disabled="isDisabled"
      class="text-area-input__input"
      @input="handleInputValue"
    />
  </form-section>
</template>

<script>
import InputCommon from './InputCommon'
export default {
  name: 'TextAreaInput',
  mixins: [InputCommon],
  props: {
    type: {
      type: String,
      default: 'text'
    },
    value: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="sass">
@import '~styles/forms/mixins'

.text-area-input__input
  @extend %form-text-input-style
  line-height: 1.5
  min-height: rem-calc(164)
  padding-bottom: rem-calc(20)
  padding-top: rem-calc(20)

</style>



// WEBPACK FOOTER //
// src/components/forms/TextAreaInput.vue